import { collection, doc, getDoc, setDoc, Timestamp, } from "firebase/firestore";
import { prepareForFirestore } from "./utils";
export const callerConverter = {
    toFirestore(value) {
        return prepareForFirestore(value);
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return {
            ...data,
            id: snapshot.id,
            firstCallAt: data.firstCallAt instanceof Timestamp
                ? data.firstCallAt.toDate()
                : data.firstCallAt
                    ? new Date(data.firstCallAt)
                    : null,
            lastCallAt: data.lastCallAt instanceof Timestamp
                ? data.lastCallAt.toDate()
                : data.lastCallAt
                    ? new Date(data.lastCallAt)
                    : null,
            createdAt: data.createdAt instanceof Timestamp
                ? data.createdAt.toDate()
                : data.createdAt
                    ? new Date(data.createdAt)
                    : null,
            updatedAt: data.updatedAt instanceof Timestamp
                ? data.updatedAt.toDate()
                : data.updatedAt
                    ? new Date(data.updatedAt)
                    : null,
        };
    },
};
export function callersCollection(db, companyId) {
    return collection(db, "companies", companyId, "callers").withConverter(callerConverter);
}
// Helper to normalize phone numbers (remove spaces)
export function normalizePhoneNumber(phone) {
    return phone.replace(/\s+/g, "");
}
export function callerDocument(db, companyId, phoneNumber) {
    const normalizedPhone = normalizePhoneNumber(phoneNumber);
    return doc(db, "companies", companyId, "callers", normalizedPhone).withConverter(callerConverter);
}
// Upsert caller: Create if not exists, update if exists (merge)
export async function updateCaller(db, companyId, phoneNumber, data) {
    // data.phoneNumber is not typically passed in data, but the arg is passed.
    // We normalize the arg to ensure the key and the stored field are consistent.
    const normalizedPhone = normalizePhoneNumber(phoneNumber);
    const docRef = callerDocument(db, companyId, normalizedPhone);
    // merge: true allows upsert behavior for setDoc
    await setDoc(docRef, {
        ...data,
        updatedAt: new Date(),
        // Ensure keys for queries if creating new
        phoneNumber: normalizedPhone,
        companyId: companyId,
    }, { merge: true });
}
export async function fetchCaller(db, companyId, phoneNumber) {
    // callerDocument handles normalization
    const docRef = callerDocument(db, companyId, phoneNumber);
    const snap = await getDoc(docRef);
    return snap.exists() ? snap.data() : null;
}
